import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "./redux/firstVisitConversionSagas";

import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import SectionToggle from "../../../../components/sectionToggle/sectionToggle";
import LearnMore from "../../../../components/learnMore/learnMore";
import CustomDateRanges from "./smartComponents/customDateRanges";
import DatePicker from "./smartComponents/datePicker";
import PieChart from "./smartComponents/pieChart";
import Table from "./smartComponents/table";

const FirstVisitConversionModule = (props) => {
  const dispatch = useDispatch();
  const {
    isLoading,
    filtersDirty,
    initialRequest,
    filtersLoading,
    datesDirty,
    // excludeIntrosToggleDisabled,
    selectedRequestDates,
    error: haveError,
    errorText,
    // toggleIntros,
    conversionInfo: conversionData
  } = useSelector((state) => state.firstVisitConversion);

  useEffect(() => {
    !initialRequest && initFetchData();
  }, []);

  const resetData = () => {
    dispatch(actionCreators.fetchCurrentUser({ data: props, resetData: true }));
  };

  const initFetchData = () => {
    dispatch(actionCreators.fetchCurrentUser({ data: props, updateFilters: false }));
  };

  const updateData = () => {
    dispatch(actionCreators.fetchCurrentUser({ data: props, updateFilters: true }));
  };

  // const toggleOffers = (event) => {
  //   dispatch(
  //     actionCreators.fetchCurrentUser({
  //       data: props,
  //       toggleOffers: event.target.checked
  //     })
  //   );
  // };

  const content = () => {
    return (
      <div>
        {!filtersLoading ? (
          <div className="edit-selections-bar">
            <div className="select-box">
              <p className="offers-title">Date Range</p>
              <CustomDateRanges />
            </div>
            <div className="date-select-box select-box multi">
              <p className="offers-title">Date</p>
              <DatePicker />
            </div>
            {/* {!excludeIntrosToggleDisabled && (
              <div className="select-box">
                <p className="offers-title">Exclude Intro Offers</p>
                <input
                  type="checkbox"
                  className="ios8-switch"
                  id="intros-only"
                  checked={toggleIntros}
                  onChange={(event) => toggleOffers(event)}
                />
                <label htmlFor="intros-only" />
              </div>
            )} */}
            {filtersDirty ||
            datesDirty &
              !isLoading &
              (selectedRequestDates.startDate !== "Invalid date") &
              (selectedRequestDates.endDate !== "Invalid date") ? (
              <button className="submit" onClick={() => updateData()}>
                Update
              </button>
            ) : null}
            {filtersDirty || datesDirty & !isLoading ? (
              <button className="submit reset" onClick={() => resetData()}>
                Reset
              </button>
            ) : null}
          </div>
        ) : null}

        {isLoading ? (
          <LoadingAnimation />
        ) : (
          <div className="first-visits-table">
            {haveError ? (
              <p className="error-text">{errorText}</p>
            ) : (
              <div>
                <div className="totals">
                  <p>
                    First Visits
                    <br />
                    <span>
                      <a
                        href={conversionData.firstVisitsRawDataLink}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {conversionData.grandTotal.firstVisits}
                      </a>
                    </span>
                  </p>
                  <p>
                    Intros Purchased
                    <br />
                    <span>
                      <a
                        href={conversionData.introsPurchasedRawDataLink}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {conversionData.grandTotal.introsPurchased}
                      </a>
                    </span>
                  </p>
                  <p>
                    Didn&lsquo;t Purchase
                    <br />
                    <span>
                      <a
                        href={conversionData.notPurchasedRawDataLink}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {conversionData.grandTotal.notPurchased}
                      </a>
                    </span>
                  </p>
                  <p>
                    Converted
                    <br />
                    <span>{conversionData.grandTotal.converted}</span>
                  </p>
                </div>
                <div className="md-table">
                  <Table />
                </div>
                <div className="md-pie">
                  <PieChart />
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  return (
    <SectionToggle
      title="First Visit Conversion Chart"
      autoHeight
      content={content()}
      learnMore={<LearnMore {...props.learnMore} html />}
    />
  );
};

export default React.memo(FirstVisitConversionModule);
